module.exports = {
  WEIGHT: 1,
  ASSESSMENT: 2,
};
